<template>
    <v-dialog v-model="dialog" scrollable :max-height="maxHeight" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : maxWidth" persistent>
        <v-card>
                <v-card-title class="ma-0 pa-0">
                    <v-app-bar dense height="45" :class="color + ' mb-4 elevation-1'">
                        <v-icon left>{{ icon }}</v-icon>
                            <v-toolbar-title class="subtitle-1">
                                <slot name="title">{{ title }}</slot>
                            </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <slot name="tools"></slot>
                        <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click.native="dialog = false" :disabled="disabled" v-bind="attrs" v-on="on">
                                        <v-icon color="red lighten-2">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Fechar</span>
                        </v-tooltip>
                    </v-app-bar>
                </v-card-title>

                <v-card-text class="pt-2">
                    <slot name="form" />
                </v-card-text>
                
                <v-card-actions v-if="actions">
                    <small v-if="footerText">{{ footerText }}</small>
                    <v-spacer></v-spacer>
                    <slot name="actions" />
                    <v-btn v-if="showButton" :color="colorButton" @click.prevent.stop="clickOk()" :loading="loading" :disabled="disabled" >{{ textButton }}<v-icon v-if="iconButton">{{ iconButton }}</v-icon></v-btn>
                </v-card-actions>

            </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "EmcFormBase",
    data: () => ({
        dialog: false,
        loading: false,
        disabled: false,
    }),
    created(){
        var vm = this
        document.addEventListener('keyup', function (evt) {
            if (evt.keyCode === 27) {
                vm.dialog = false
            }
        });
    },
    computed: {
        
    },
    watch: {
        
        dialog() {
            this.$emit('update:show', this.dialog);
        },

        show(val) {
            
            this.dialog = val;
        },

    },
    props: {
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        maxHeight:{
            type: String,
            default: "auto"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            requered: false
        },
        textButton: {
            type: String,
            default: "OK"
        },
        iconButton: {
            type: String,
            default: null
        },
        colorButton: {
            type: String,
            default: 'primary'
        },
        show: {
            type: Boolean,
            default: false
        },
        actions: {
            type: Boolean,
            default: true
        },
        showButton: {
            type: Boolean,
            default: true
        },
        footerText: {
            type: String,
            default: null
        }
    },
    methods:{
        
        clickOk(){
            this.$emit('onOk');
        },

    }
}
</script>